// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*,body{margin:0}*{padding:0;border:none;vertical-align:baseline;list-style:none;border-collapse:collapse;border-spacing:0}#yunque_btn-holder{display:none}", ""]);
// Exports
module.exports = exports;
